export const DEFAULT_WEIGHT_THRESHOLD = 50;

export class AnimalCount {
  animals_on_site?: number;
  grouped_not_closed?: number;
  to_register?: number;
  animals_on_site_by_color_and_gender?: AnimalCountByColorAndGender[];
  project_animals?: number;
  weight_threshold?: number;
  ride_animals_without_purchase_order?: number;
  ride_animals_without_purchase_order_by_color_and_gender?: AnimalCountByColorAndGender[];
}

export class AnimalCountByColorAndGender {
  color_id: number;
  total: number;
  color: string;
  gender: string;
  gender_id: number;
  weight_category?: string;
}

export function isBelowWeightThreshold(category?: string): boolean {
  return category === 'below_threshold' || category === 'tot_50_kg';
}

export function isAboveWeightThreshold(category?: string): boolean {
  return category === 'above_threshold' || category === '50_kg_en_hoger';
}

export function weightCategoryLabel(
  category?: string,
  threshold: number = DEFAULT_WEIGHT_THRESHOLD
): string {
  if (!category) {
    return '';
  }
  if (isBelowWeightThreshold(category)) {
    return `tot ${threshold}`;
  }
  if (isAboveWeightThreshold(category)) {
    return `meer dan ${threshold}`;
  }
  if (category === 'onbekend') {
    return 'onbekend';
  }
  return category;
}

export function weightCategorySortOrder(category?: string): number {
  if (isBelowWeightThreshold(category)) {
    return 0;
  }
  if (isAboveWeightThreshold(category)) {
    return 1;
  }
  return 2;
}
